/*
 * @Author: Jhonsem
 * @Date: 2018-11-08 10:22:57
 * @Last Modified by: Jhonsem
 * @Last Modified time: 2018-11-08 15:55:21
 */
import store from "@/store/index";
import * as types from "@/store/constants/types";
import * as statusConst from "@/store/constants/status";
import * as AppLifeCycle from "@/utils/appLifeCycle";
class EarnCoinCountDownManager {
  private countDownMap: any = new Map();
  private applifeKeyName: string = "EarnCoinCountDownManagerAppLifeCycle";

  public initialCountDownManager() {
    console.log("开始initialCountDownManager");
    this.clearAllTimeInterval();

    const restrictedUserList = store.getters[types.GETTER_EARN_COIN_USER_LIST](
      "restricted"
    );
    const newRestrictedUserList = restrictedUserList.filter((user: any) => {
      return (
        user.restrictedType && user.restrictedType === statusConst.TIME_LIMIT
      );
    });

    //检查是否已经有过期的：
    const userStatusList = store.getters[types.GETTER_USER_STATUS_LIST];
    userStatusList.forEach((userStatus: any) => {
      if (
        userStatus.status === statusConst.TIME_LIMIT &&
        userStatus.limitedEndTimeStamp &&
        userStatus.limitedEndTimeStamp <= new Date().valueOf()
      ) {
        console.log("检查时间已经过期了(manager的）：", userStatus.userId);
        this.normalizeUserStatus(userStatus.userId);
      }
    });

    for (const restrictedUser of newRestrictedUserList) {
      this.startLimitedCountDown(restrictedUser);
    }

    this.countDownListenAppLifeCycle();
  }

  private startLimitedCountDown(userData: any) {
    console.log("startLimitedCountDown:", userData);
    //检查时间是否过期：
    if (
      userData.limitedEndTimeStamp &&
      userData.limitedEndTimeStamp > new Date().valueOf()
    ) {
      const diffTime = Math.round(
        (userData.limitedEndTimeStamp - new Date().valueOf()) / 1000
      );
      this.setIntervalTimer(userData.userId, diffTime);
    } else {
      this.normalizeUserStatus(userData.userId);
    }
  }

  private normalizeUserStatus(userId: number) {
    const newUserStatus = {
      userId,
      status: statusConst.NORMAL,
      limitedEndTimeStamp: null
    };
    store.commit(types.UPDATE_USER_STATUS, newUserStatus);
    console.log("更新了用户的状态：", newUserStatus);
  }

  private setIntervalTimer(userId: number, time: number) {
    let countDownTime = time;
    console.log("开始limted的倒计时（manager的）:", {
      userId,
      countDownTime
    });
    const newIntervalTimer = setInterval(() => {
      countDownTime -= 1;
      console.log("limitedCountNum (manager的）:", countDownTime);
      if (countDownTime <= 0) {
        this.normalizeUserStatus(userId);
        this.clearIntervalTimer(userId);
      }
    }, 1000);
    this.countDownMap.set(userId, newIntervalTimer);
  }

  private clearIntervalTimer(userId: number) {
    if (this.countDownMap.has(userId)) {
      const timer = this.countDownMap.get(userId);
      console.log("获取到了timer准备清除:", {
        timer,
        userId
      });
      clearInterval(timer);
      this.countDownMap.delete(userId);
    }
  }

  private clearAllTimeInterval() {
    for (const value of this.countDownMap.values()) {
      console.log(value);
      clearInterval(value);
    }
    this.countDownMap.clear();
    this.countDownRemoveListenrAppLifeCycle();
  }

  private countDownListenAppLifeCycle() {
    console.log("执行了countDownListenAppLifeCycle");
    AppLifeCycle.addListener({
      key: this.applifeKeyName,
      fn: async () => {
        console.log("监听到了前后台的切换:执行countDownListenAppLifeCycle");
        this.initialCountDownManager();
      }
    });
  }

  private countDownRemoveListenrAppLifeCycle() {
    console.log("清除掉countDownRemoveListenrAppLifeCycle的前后台切换倒计时");
    AppLifeCycle.removeListener(this.applifeKeyName);
  }
}

const EarnCoinCountDownManagerInstance = new EarnCoinCountDownManager();
export default EarnCoinCountDownManagerInstance;
